import React from 'react';
import spotifyWeeble from '../../../images/salescatalyst/female-shoppers_spotify_weeble.png';
import { TEASER_EMAIL_CATALYST } from '../../../actions/urlTypes';

const SalesCatalystComingSoonTeaser = () => (
  <div className="sales-catalyst sc-coming-soon-panel">
    <div className="large-12 medium-12 small-12 columns heading1">
      {'Available Now!'}
    </div>
    <div className="large-12 medium-12 small-12 columns heading2" >
      {'Contact your representative or '}
      {<u><a href={`mailto:${TEASER_EMAIL_CATALYST}`}>{TEASER_EMAIL_CATALYST}</a></u>}
      {' for more Information.'}
    </div>
    <div className="large-12 medium-12 small-12 columns heading3">
      <div className="large-6 medium-6 small-6 columns heading3-left">
        <img src={spotifyWeeble} alt="spotify_weeble" />
      </div>
      <div className="large-6 medium-6 small-6 columns heading3-right">
        <ul>
          <li>
            {'Discover the overlap between you and the desired target market.'}
          </li>
          <li>
            {'Identify the package you offer that best reaches the target market.'}
          </li>
          <li>
            {'Compare yourself with your competitors and assess your opportunities for securing the target market over the competition'
            + ' and the threats for losing the target market to the competition.'}
          </li>
        </ul>
      </div>
    </div>
  </div>
);

export default SalesCatalystComingSoonTeaser;
